const KEY = "krithios:visits";

export interface VisitInfo {
    returning: boolean;
    visits: number;
    daysAway: number | null;
}

interface Stored {
    count: number;
    last: string;
}

function read(): Stored | null {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as Stored;
        if (typeof parsed?.count !== "number") return null;
        return parsed;
    } catch {
        return null;
    }
}

let cached: VisitInfo | null = null;

/** Reads the previous visit and records this one. Safe to call repeatedly — only the first call writes. */
export function visitInfo(): VisitInfo {
    if (cached) return cached;
    const prev = read();
    const now = Date.now();
    const daysAway = prev ? Math.floor((now - new Date(prev.last).getTime()) / 86_400_000) : null;
    cached = {
        returning: Boolean(prev),
        visits: (prev?.count ?? 0) + 1,
        daysAway: prev ? (Number.isFinite(daysAway as number) ? daysAway : 0) : null,
    };
    try {
        localStorage.setItem(KEY, JSON.stringify({ count: cached.visits, last: new Date(now).toISOString() }));
    } catch {
        /* session-only */
    }
    return cached;
}

export function awayLabel(days: number | null): string {
    if (days === null) return "";
    if (days <= 0) return "earlier today";
    if (days === 1) return "yesterday";
    if (days < 7) return `${days} days ago`;
    if (days < 30) return `${Math.floor(days / 7)} week${days < 14 ? "" : "s"} ago`;
    return `${Math.floor(days / 30)} month${days < 60 ? "" : "s"} ago`;
}
